import { Node, mergeAttributes } from '@tiptap/core';

// A video placed inline in post content — deliberately NOT a live iframe
// while stored/edited, just a marker div carrying the URL. The public page
// (RichContent.jsx) scans the sanitized HTML for this marker and swaps it
// for a real <SocialVideoEmbed>, so the video only ever actually loads on
// the published page, not from raw HTML round-tripping through the API.
// This is what keeps a "paste a URL" video at zero server storage cost,
// same as the single hero-video field, just positionable anywhere in the body.
export const VideoEmbed = Node.create({
  name: 'videoEmbed',
  group: 'block',
  atom: true,
  draggable: true,

  addAttributes() {
    return {
      url: { default: null },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-video-embed]', getAttrs: el => ({ url: el.getAttribute('data-video-embed') }) }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-video-embed': HTMLAttributes.url }),
      ['span', {}, `▶ Video: ${HTMLAttributes.url || ''}`]];
  },

  addCommands() {
    return {
      setVideoEmbed: url => ({ commands }) => commands.insertContent({ type: this.name, attrs: { url } }),
    };
  },
});
